import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FilterType, SortOption } from '../models/filter.model';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { ApiResponse } from '../models/response.model';
import { map } from 'rxjs/operators';
import { AppConstants } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class FilterService {

  sortOptions: SortOption[] = [
    {
      key: 'price',
      label: 'Price - Low to High',
      value: '1',
    },
    {
      key: 'price',
      label: 'Price - High to Low',
      value: '-1',
    },
    {
      key: 'listingPriority',
      label: 'Relevance',
      value: '0',
    },
    {
      key: 'availabilityInDays',
      label: 'Availability in Days',
      value: '1',
    },
  ];
  private _filterEndpoint = `${environment.apiBaseUrl}/vehicle/v1`;

  constructor(private _http: HttpClient) {

  }

  getFilterTypes(): Observable<FilterType> {
    const params: any = {};
    // Always send currently selected city
    const cityName = localStorage.getItem(AppConstants.CURRENT_CITY_KEY);
    if (cityName) params['city'] = cityName.replace('-', ' ');
    return this._http
      .get<ApiResponse<any>>(this._filterEndpoint + '/vehicles/filters', { params, })
      .pipe(map((res) => res.data));
  }

  getSortOptions(): Observable<SortOption[]> {
    return of(this.sortOptions);
  }
}